import React, { SFC } from "react";
import Image, { PropsType as ImagePropsType } from "../Image";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PropsType = WithContentWrapProps &
    WithVerticalSpacingProps &
    HTMLProps<HTMLDivElement> & {
        backgroundImage?: string;
        image: {
            src: string;
            srcSet: string;
        };
        mask?: "mask1" | "mask2" | "mask3";
        title: string;
    };

const BlockImage = (props: PropsType): SFC => {
    const mask = props.mask ? `BlockImage--${props.mask}` : "";
    const background = props.background ? `BlockImage--background` : "";
    const className = `BlockImage ${mask} ${background}`;

    return (
        <div className={className}>
            {props.backgroundImage && (
                <div className="BlockImage__background">
                    <img src={props.backgroundImage} />
                </div>
            )}
            <div className="BlockImage__image">
                <img src={props.image.src} srcSet={props.image.srcSet} />
                <img src={props.image.src} srcSet={props.image.srcSet} />
                <img src={props.image.src} srcSet={props.image.srcSet} />
            </div>
        </div>
    );
};

export default withVerticalSpacing(withContentWrap(BlockImage));
